import { IcClose } from '@yanolja-org/nol-icons';

import { LogoOrAction } from './LogoOrAction';

import type { HeaderLogoProps } from '@yanolja-org/core-ui';

export interface LogoOrCloseProps {
  /** Logo 케이스 — Header.Logo 의 logo prop pass-through. 미명시 시 bi widget 자동 fetch */
  logo?: HeaderLogoProps['logo'];
  /** Logo 케이스 — Header.Logo 의 href. SEO crawler 의 link graph 용도. @default '/' */
  logoHref?: string;
  /** Close 케이스 — Header.Action 의 action 식별자. @default 'close' */
  closeAction?: string;
  /** 공통 — className */
  className?: string;
}

export function LogoOrClose({ logo, logoHref = '/', closeAction = 'close', className }: LogoOrCloseProps) {
  return <LogoOrAction action={closeAction} className={className} icon={<IcClose />} logo={logo} logoHref={logoHref} />;
}
